import { Offcanvas } from "react-bootstrap";
import { renderCell } from "../../apps/invoicesSides";
import StatusPill from "./StatusPill";

export default function ErpDetailPanel({ row, onClose }) {
   const show = !!row;
   const line = (label, value) => (
      <div className="d-flex justify-content-between py-2 border-bottom">
         <span className="text-secondary">{label}</span>
         <span>{value}</span>
      </div>
   );
   return (
      <Offcanvas show={show} onHide={onClose} placement="end">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>ERP invoice</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body>
            {row && (
               <>
                  {line("Supplier", row.supplier)}
                  {line("Invoice number", row.invoice_no)}
                  {line("Invoice date", renderCell("date", row.invoice_date))}
                  {line("ERP amount", renderCell("money", row.erp_amount))}
                  {line("Matched", renderCell("money", row.allocated))}
                  {line("Variance", renderCell("money", row.variance))}
                  {line("Status", <StatusPill status={row.match_status} />)}
                  <p className="text-secondary mt-3 mb-0">No statement counterpart found for this ERP invoice.</p>
               </>
            )}
         </Offcanvas.Body>
      </Offcanvas>
   );
}
